<script setup>
import WebPageLayout from "@/Layouts/WebPageLayout.vue";
import {Head} from '@inertiajs/vue3';
import Gallery from "@/Components/Gallery.vue"</script>

<template>
    <Head title="Activiteiten">
        <meta content="Activiteiten" name="title">
        <meta content="Hier vind je alle geweldige activiteiten die wij organiseren op onze kinderboerderij en jeugdverblijfcentrum in Montenaken."
              name="description">
        <meta content="index, follow" name="robots">
    </Head>

    <WebPageLayout>
        <Gallery :items="gallerij"/>
    </WebPageLayout>

</template>

<script>
export default {
    name: "Activiteiten",
    data() {
        return {
            gallerij: [
                {
                    imgLink: '/public/storage/Afbeeldingen/Activiteiten/Gallerij/Kampen.jpg',
                    routeLink: route("kampen.algemeen"),
                    text: 'Kampen',
                    height: 35,
                    gridArea: '1 / 1 / span 2 / span 1',
                },
                {
                    imgLink: '/public/storage/Afbeeldingen/Activiteiten/Gallerij/Familiedag.jpg',
                    routeLink: route("activiteiten.familiedagen"),
                    text: 'Familiedag',
                    height: 17,
                    gridArea: '1 / 2 / span 1 / span 2',
                },
                {
                    imgLink: '/public/storage/Afbeeldingen/Activiteiten/Gallerij/Verjaardagsfeest.jpg',
                    routeLink: route("activiteiten.verjaardagsfeest"),
                    text: 'Verjaardagsfeest',
                    height: 17,
                    gridArea: '2 / 2 / span 1 / span 1',

                },
                {
                    imgLink: '/public/storage/Afbeeldingen/Activiteiten/Gallerij/Kidsdays.jpg',
                    routeLink: route("activiteiten.kidsdays"),
                    text: 'Kidsday',
                    height: 17,
                    gridArea: '2 / 3 / span 1 / span 1',
                },
                {
                    imgLink: '/public/storage/Afbeeldingen/Activiteiten/Gallerij/Scholen.jpg',
                    routeLink: route("activiteiten.scholen"),
                    text: 'Scholen',
                    height: 17,
                    gridArea: '3 / 3 / span 1 / span 1',
                },
                {
                    imgLink: '/public/storage/Afbeeldingen/Activiteiten/Gallerij/Jeugdverblijfcentrum.jpg',
                    routeLink: route("activiteiten.jeugdverblijfcentrum"),
                    text: 'Jeugdverblijfcentrum',
                    height: 17,
                    gridArea: '3 / 1 / span 1 / span 2',
                },
                {
                    imgLink: '/public/storage/Afbeeldingen/Activiteiten/Gallerij/Dierenmobiel.jpg',
                    routeLink: route("activiteiten.dierenmobiel"),
                    text: 'Dierenmobiel',
                    height: 17,
                    gridArea: '4 / 1 / span 1 / span 3',
                },
            ]
        }
    }
}
</script>

<style scoped>

</style>
